/**
 * This file contains helpers for direct linking, but most things are isolated to the module itself.
 * Anything exported from here should be considered for deep linking rather than general navigation.
 */
import { generatePath } from 'react-router';

// React Router v7's `generatePath` only accepts string params.
type RouteParams = Record<string, string>;

export type LabRouteType = {
  path: string;
  build: (params?: RouteParams) => string;
  relativePath?: string;
};

export const labsRoutes: Record<string, LabRouteType> = {
  labs: {
    path: '/labs/*',
    build() {
      return generatePath(this.path, { '*': '' });
    },
  },
  pastLabs: {
    path: '/labs/past',
    build() {
      return generatePath(this.path);
    },
  },
  result: {
    path: '/labs/detail/:id/view',
    relativePath: 'detail/:id/view',
    build(params) {
      return generatePath(this.path, params);
    },
  },
  document: {
    path: '/labs/document/:id/view',
    relativePath: 'document/:id/view',
    build(params) {
      return generatePath(this.path, params);
    },
  },
  purpose: {
    path: '/labs/purpose',
    relativePath: 'purpose',
    build() {
      return generatePath(this.path);
    },
  },
  meaning: {
    path: '/labs/meaning',
    relativePath: 'meaning',
    build() {
      return generatePath(this.path);
    },
  },
  instructions: {
    path: '/labs/instructions',
    relativePath: 'instructions',
    build() {
      return generatePath(this.path);
    },
  },
} as const;
